import React from 'react'
import styles from './ImageTextBox.module.sass'

export default function ImageTextBox({
  intro = '',
  title = '',
  description = '',
  image = null,
  zoom = false,
}) {
  return (
    <div className={styles.root} >
      <div className={`${styles.content} scroll-fadein`}>
        {!!intro && <p className={styles.intro}>{intro}</p>}
        {!!title && <h1 className={styles.title}>{title}</h1>}
        {!!description && (
			<div className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />
        )}
      </div>
      <div className={`${styles.imageBox} scroll-fadein-late`}>
        {!!image && <img src={image} />}
      </div>
    </div>
  )
}
